import "./src/styles/global.css";
import { reportNetlifyInsight } from "./src/utils/netlifyInsights.js";

export const onClientEntry = () => {
	if (typeof window === "undefined" || typeof document === "undefined") return;
	if (!document.body) return;

	const parseExternalHref = (href) => {
		try {
			return new URL(href, window.location.origin);
		} catch (_) {
			return null;
		}
	};

	const hostnameLabel = (url) =>
		url.hostname.replace(/^www\./, "").slice(0, 48);

	document.body.addEventListener(
		"click",
		(e) => {
			const a = e.target.closest("a[href]");
			if (!a) return;

			const raw = a.getAttribute("href") || "";

			if (raw.startsWith("mailto:")) {
				reportNetlifyInsight("mailto", "click");
				return;
			}
			if (raw.startsWith("tel:")) {
				reportNetlifyInsight("tel", "click");
				return;
			}

			if (raw === "#contact" || raw.startsWith("#contact?")) {
				reportNetlifyInsight("nav-contact", "click");
				return;
			}

			const url = parseExternalHref(raw);
			if (url && url.origin !== window.location.origin) {
				if (["http:", "https:"].includes(url.protocol))
					reportNetlifyInsight(
						url.protocol === "https:" ? "outbound-link" : "outbound-http",
						`${hostnameLabel(url)}${url.pathname}`,
					);
				return;
			}

			try {
				if (url && url.pathname.startsWith("/media/demos")) {
					if (a.hasAttribute("download")) {
						reportNetlifyInsight(
							"demo-download",
							decodeURIComponent(url.pathname.split("/").pop() || "file"),
						);
					}
				}
			} catch (_) {}
		},
		true,
	);
};